export default __webpack_public_path__ + "static/media/logo.ad1fd0d3.svg";